import script from "./ReplyCase.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReplyCase.vue?vue&type=script&setup=true&lang=ts"

import "./ReplyCase.vue?vue&type=style&index=0&id=f5da1b8e&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5da1b8e"]])

export default __exports__